import { InvoicingConfig } from "../../../../../Invoices/screens/payables/InvoicingConfig";

export const RoutePayables: React.FC = () => {
  return <InvoicingConfig isEditing />;
};
